<template>
<!--    <div>-->
        <div class="g-main g-wrap">
            <h2 class="m-title">
                <strong>普通查询</strong>
                <a  @click="checkispro()" class="u-button default f-right">高级查询</a>
            </h2>
            <div class="m-mainbox">
                <table width="100%" border="0" class="m-tableform search">
                    <tr>
                        <th width="150">数据维度：</th>
                        <td>
                            <div class="m-searchnav">
                                <a :class="{cur:actives === 1}" @click="changedata(1)">学历需求量</a>
                                <a :class="{cur:actives === 2}" @click="changedata(2)">岗位需求量</a>
                                <a :class="{cur:actives === 3}" @click="changedata(3)">Top20行业需求量</a>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>查询条件：</th>
                        <td></td>
                    </tr>
                    <tr v-show="isareashow">
                        <th>地点：</th>
                        <td>
                            <div class="m-searchnav2">
                                <a :class="{cur:proactives === 1}" @click="showPro(1)">{{province}}<i
                                        :class="{'icon-up':prostyle===2,'icon-down':prostyle===1}"></i></a>
                                <a :class="{cur:proactives === 2}" @click="showPro(2)">{{city}}<i
                                        :class="{'icon-up':citystyle===2,'icon-down':citystyle===1}"></i></a></div>
                            <div class="m-searchcon" v-show="isProshow">
                                <template v-for="item in Provincelists">
                                    <a :class="{cur:province === item.name}"
                                       @click="changepro(item.name)">{{item.name}}</a>
                                </template>
                            </div>
                            <div class="m-searchcon city" v-show="isCityshow">
                                <template v-for="item in Citylists">
                                    <a :class="{cur:city === item.shortname}" @click="changepro(item.shortname)">{{item.shortname}}</a>
                                </template>
                            </div>
                        </td>
                    </tr>
                    <tr v-show="careershow">
                        <th>岗位：</th>
                        <td>
                            <div class="m-searchnav2">
                                <a :class="{cur:careeractives === 1}" @click="showCareer(1)">{{careergroup}}<i
                                        :class="{'icon-up':grostyle===2,'icon-down':grostyle===1}"></i></a>
                                <a :class="{cur:careeractives === 2}" @click="showCareer(2)">{{career}}<i
                                        :class="{'icon-up':careerstyle===2,'icon-down':careerstyle===1}"></i></a></div>
                            <div class="m-searchcon" v-show="isGroshow">
                                <template v-for="item in careergrouplist">
                                    <a :class="{cur:careergroup === item}"
                                       @click="changecareer(item)">{{item}}</a>
                                </template>
                            </div>
                            <div class="m-searchcon city" v-show="isCareershow">
                                <template v-for="item in careerlist">
                                    <a :class="{cur:career === item}" @click="changecareer(item)">{{item}}</a>
                                </template>
                            </div>
                        </td>
                    </tr>
                    <tr v-show="istimeshow">
                        <th>时间：</th>
                        <td>
                            <el-date-picker
                                    v-model="starttime"
                                    type="month"
                                    placeholder="选择开始时间">
                            </el-date-picker>
                            ~~
                            <el-date-picker
                                    v-model="endtime"
                                    type="month"
                                    placeholder="选择结束时间">
                            </el-date-picker>
                        </td>
                    </tr>
                    <tr v-show="isedushow">
                        <th>学历：</th>
                        <td>
                            <div class="m-searchnav">
                                <a :class="{cur:edurange === '不限'}" @click="changeedu('不限')">不限</a>
                                <a :class="{cur:edurange === '初中'}" @click="changeedu('初中')">初中</a>
                                <a :class="{cur:edurange === '中技'}" @click="changeedu('中技')">中技</a>
                                <a :class="{cur:edurange === '中专'}" @click="changeedu('中专')">中专</a>
                                <a :class="{cur:edurange === '高中'}" @click="changeedu('高中')">高中</a>
                                <a :class="{cur:edurange === '大专'}" @click="changeedu('大专')">大专</a>
                                <a :class="{cur:edurange === '本科'}" @click="changeedu('本科')">本科</a>
                                <a :class="{cur:edurange === '硕士'}" @click="changeedu('硕士')">硕士</a>
                                <a :class="{cur:edurange === '博士'}" @click="changeedu('博士')">博士</a>
                            </div>
                        </td>
                    </tr>
                    <tr v-show="ispayshow">
                        <th>薪资范围：</th>
                        <td>
                            <div class="m-searchnav">
                                <a :class="{cur:payrange === 0}" @click="changepay(0)">不限</a>
                                <a :class="{cur:payrange === 1}" @click="changepay(1)">2K-4K</a>
                                <a :class="{cur:payrange === 2}" @click="changepay(2)">4K-6K</a>
                                <a :class="{cur:payrange === 3}" @click="changepay(3)">6K-8K</a>
                                <a :class="{cur:payrange === 4}" @click="changepay(4)">8K-10K</a>
                                <a :class="{cur:payrange === 5}" @click="changepay(5)">10K-15k</a>
                                <a :class="{cur:payrange === 6}" @click="changepay(6)">15k以上</a>
                            </div>
                        </td>
                    </tr>
                    <tr v-show="isexpshow">
                        <th>工作经验：</th>
                        <td>
                            <div class="m-searchnav">
                                <a :class="{cur:exprange === 0}" @click="changeexp(0)">不限</a>
                                <a :class="{cur:exprange === 1}" @click="changeexp(1)">应届生</a>
                                <a :class="{cur:exprange === 2}" @click="changeexp(2)">一年</a>
                                <a :class="{cur:exprange === 3}" @click="changeexp(3)">两年</a>
                                <a :class="{cur:exprange === 4}" @click="changeexp(4)">三年</a>
                                <a :class="{cur:exprange === 5}" @click="changeexp(5)">四年</a>
                                <a :class="{cur:exprange === 6}" @click="changeexp(6)">五年及以上</a>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th></th>
                        <td class="searchbtns"><a class="u-button primary search" href="javascript:void(0);"
                                                  @click="jobsearch">查询</a></td>
                    </tr>
                </table>

                <h2 class="m-title"><strong>查询结果</strong></h2>
                <div class="f-clear" id="page01" style="width:100%;height:400px;"></div>
                <div class="u-spaceline f-clear"></div>


            </div>
            <loginer ref="loginer"></loginer>
            <popuper ref="popuper"></popuper>
        </div>

<!--    </div>-->
</template>

<script>
    import Loginer from "../loginer";
    import Popuper from "../popuper";
    export default {
        name: "search",
        components: {Loginer,Popuper},
        data() {
            return {
                isareashow:true,//地点条件
                careershow:false,//岗位条件
                istimeshow:false,//时间条件
                isedushow:false,//学历条件
                ispayshow:false,//薪资条件
                isexpshow:false,//工作经验条件
                starttime: '',
                endtime: '',
                actives: 1,
                proactives: 1,
                prostyle: 1,
                citystyle: 1,
                isProshow: false,
                isCityshow: false,
                careeractives: 1,
                grostyle: 1,
                careerstyle: 1,
                isGroshow: false,
                isCareershow: false,
                province: "省份",
                city: "城市",
                careergroup: "岗位群",
                career: "岗位",
                edurange: "不限",
                Provincelists: cityProvinces,
                Citylists: [],
                selCitys: [],
                payrange: 0,
                exprange:0,
                record:[],
                careergrouplist:[],
                careerlist:[]
            };
        },
        computed:{
            datamem(){
                return this.$store.state.user.datamem;
            },
            useraccount(){
                return this.$store.state.user.useraccount;
            },
        },
        created() {
            this.init();
        },
        methods: {
            checkurl(url) {
                if (url.indexOf('?') !== -1) {
                    return url = url + "&";
                } else {
                    return url = url + "?";
                }
            },
            async jobsearch() {
                if(this.useraccount){
                    let url = '/jobs/search';
                    if (this.province!=='省份') {//地点
                        url = this.checkurl(url) + 'province=' + this.province;
                    }
                    if (this.city!=='城市') {
                        url = this.checkurl(url) + 'city=' + this.city;
                    }
                    if(this.starttime&&this.endtime){//时间
                        let stardate = new Date(this.starttime);
                        let enddate = new Date(this.endtime);
                        let starttime=stardate.getFullYear() + '-' + (stardate.getMonth() + 1 < 10 ? '0' + (stardate.getMonth() + 1) : stardate.getMonth() + 1) + '-01';
                        let endtime=enddate.getFullYear() + '-' + (enddate.getMonth() + 1 < 10 ? '0' + (enddate.getMonth() + 1) : enddate.getMonth() + 1)+ '-01';
                        url = this.checkurl(url) + 'starttime='+starttime+'&endtime='+endtime;
                    }
                    if (this.careergroup!=='岗位群') {//岗位群
                        url = this.checkurl(url) + 'careergroup=' + this.careergroup;
                    }
                    if (this.career!=='岗位') {//岗位
                        url = this.checkurl(url) + 'career=' + this.career;
                    }
                    if (this.edurange!=='不限') {//学历
                        url = this.checkurl(url) + 'edu=' + this.edurange;
                    }
                    let paylim;
                    let map = { '1': {minl:2000,maxl:4000}, '2': {minl:4000,maxl:6000}, '3': {minl:6000,maxl:8000}, '4': {minl:8000,maxl:10000},'5':{minl:10000,maxl:15000},'6':{minl:15000,maxl:9999999}};
                    paylim = map[this.payrange];
                    console.log(paylim);
                    if(this.payrange!==0){//薪资
                        url = this.checkurl(url) + 'minl='+paylim.minl+'&maxl='+paylim.maxl;
                    }
                    // let explim;
                    // let expmap = { '1': {expll:0,expul:1}, '2': {expll:1,expul:2}, '3':{expll:2,expul:3}, '4': {expll:3,expul:4},'5':{expll:4,expul:5},'6':{expll:5,expul:99}};
                    // explim = expmap[this.exprange];
                    if(this.exprange!==0){//薪资
                        url = this.checkurl(url) + 'exp='+this.exprange;
                    }
                    if(this.actives){//维度
                        url = this.checkurl(url) + 'type=' + this.actives;
                    }
                    this.record = await this.ajax.getJson(url);
                    console.log(this.record);
                    this.init();
                }else{
                    this.$refs.loginer.show();
                }

            },
            async init() {//初始化
                $(document.body).attr("style", "background-color:#e1e1df");
                let careergroupname = [];
                $(hotcareer).each(function (i, v) {
                    careergroupname.push(v.type);
                });
                this.careergrouplist =careergroupname;
                if(this.record.length!==0){
                    let countSalaryArray = [];//需求量
                    let avgSalaryArray = [];//平均薪资
                    let jobArray = [];//x轴
                    $.each(this.record.cntPayavgGroup, function (a, b) {
                        countSalaryArray.push(b.cnt);
                        avgSalaryArray.push(parseInt(b.payavg));
                        jobArray.push(b.name);
                    });
                    let maxCount = Math.max.apply(null, countSalaryArray);//最大需求量
                    let maxSalary = Math.max.apply(null, avgSalaryArray);//最大薪资
                    let myChart = echarts.init(document.getElementById('page01'));
                    optionsearch.series[0].data = countSalaryArray;
                optionsearch.xAxis[0].data = jobArray;
                optionsearch.yAxis[0].max = maxCount;
                optionsearch.yAxis[0].interval = Math.ceil(maxCount / 4);
                console.log(this.usertype);
                if(this.datamem){
                    let yAxis = {type: 'value',
                        name: '月薪',
                        min: 0,
                        max: 25,
                        interval: 5,
                        axisLabel: {
                            formatter: '{value} 元'}};
                    let series = {
                        name: '平均薪资',
                        type: 'line',
                        yAxisIndex: 1,
                        data:0
                    };
                    optionsearch.yAxis.splice(1);
                    optionsearch.yAxis.push(yAxis);
                    optionsearch.series.push(series);
                    optionsearch.series[1].data = avgSalaryArray;
                    optionsearch.yAxis[1].max = maxSalary;
                    optionsearch.yAxis[1].interval = Math.ceil(maxSalary / 4);
                }
                myChart.hideLoading();
                myChart.setOption(optionsearch);
            }

            },
            checkispro(){
                if(this.datamem){
                    this.careershow=true,//岗位条件
                        this.istimeshow=true,//时间条件
                        this.ispayshow=true,//薪资条件
                        this.isexpshow=true;//工作经验条件
                }else{
                    this.$refs.popuper.show({type:"3"});
                }
            },
            changedata(index) {
                this.actives = index;
                if(this.datamem){
                    if(index === 2){
                        this.careershow = false;
                    }else if(index === 1){
                        this.isedushow = false;
                    }else{
                        this.careershow = true;
                        this.isedushow = true;
                    }
                }
            },
            changepro(pro) {
                if (this.proactives === 1) {
                    this.province = pro;
                    this.city = "城市";
                } else {
                    this.city = pro;
                }
            },
            changecareer(career) {
                if (this.careeractives === 1) {
                    this.careergroup = career;
                    this.career = "岗位";
                } else {
                    this.career = career;
                }
            },
            changepay(index) {
                this.payrange = index;
            },
            changeexp(index) {
                this.exprange = index;
            },
            changeedu(msg) {
                this.edurange = msg;
            },
            showPro(e) {
                this.proactives = e;
                if (e === 1) {
                    if (this.isProshow) {
                        this.prostyle = 1;
                        this.isCityshow = false;
                        this.isProshow = false;
                    } else {
                        this.prostyle = 2;
                        this.isCityshow = false;
                        this.isProshow = true;
                    }
                } else {
                    if (this.isCityshow) {
                        this.citystyle = 1;
                        this.isCityshow = false;
                        this.isProshow = false;
                    } else {
                        this.citystyle = 2;
                        this.isCityshow = true;
                        this.isProshow = false;
                    }
                    if (this.province !== "省份") {
                        let province = this.province;
                        let index = cityProvinces.findIndex(function (data) {
                            return province === data.name;
                        });
                        console.log(index);
                        console.log(cityCities[index]);
                        this.Citylists = cityCities[index];
                    }

                }
            },
            showCareer(e){
                this.careeractives = e;
                if (e === 1) {
                    if (this.isGroshow) {
                        this.grostyle = 1;
                        this.isCareershow = false;
                        this.isGroshow = false;
                    } else {
                        this.grostyle = 2;
                        this.isCareershow = false;
                        this.isGroshow = true;
                    }
                } else {
                    if (this.isCareershow) {
                        this.careerstyle = 1;
                        this.isCareershow = false;
                        this.isGroshow = false;
                    } else {
                        this.careerstyle = 2;
                        this.isCareershow = true;
                        this.isGroshow = false;
                    }
                    if (this.careergroup !== "岗位群") {
                        let careergroup = this.careergroup;
                        let that = this;
                        $(hotcareer).each(function (i, v) {
                            let careername = v.type;
                            if(careergroup === careername){
                                that.careerlist = v.name;
                            }
                        });
                    }

                }
            }

        }
    };
</script>
<style>
    .m-tableform input[type=text] {
        width: 236px;
        height: 38px;
    }
</style>
